import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";
import HTTP from "./config/api.js";
import global from "@/core/global/global.js";
import { noConflict } from "jquery";
import { jsonp } from 'vue-jsonp'

let dev = "/tsg-author";
let dev1 = "/txpy-web";
let dev2 = "/apis/zw-user";

const URL3 = "https://wxtest.cnknowledge.com/api";
const URL4 = "https://zwi.cnknowledge.com/api";
// const URL5 = "http://112.126.62.200:5052/api";
const URL5 = "https://zwiii.cnknowledge.com/api"

let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.0.0.1") != -1 ||
    location.host.indexOf("localhost") != -1 ||
    location.host.indexOf("8088") != -1
  ) {
    url = URL3; // 投审稿作者端测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = URL5; // 投审稿作者端预生产环境
  } else {
    url = URL4; // 投审稿作者端正式环境
  }
  return url;
};

const BASE_URL = getAuthorUrl();

const apis = {
  //获取用户系信息
  getUser(data) {
    return request({
      url: dev + "/web/sso/getUser",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //查看注册信息设置
  getRegister(data) {
    return request({
      url: dev + "/web/sso/getRegister",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //修改密码
  getSign(data) {
    return request({
      url: dev + "/web/sso/resetPassword/sign",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*期刊简介*/
  periodicalsInfo(data) {
    //期刊简介信息/web/per/get
    return request({
      url: dev + "/web/per/getNew",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*切换期刊开关*/
  switchPeriodicalOpen(data) {
    return request({
      url: dev + "/web/per/switchPeriodicalOpen",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*作者投稿*/
  queryEditingByUserId(data) {
    //责任采编
    return request({
      url: dev + "/web/submit/queryEditingByUserId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  querycopyrightAgreement(data) {
    //版权协议
    return request({
      url: dev + "/web/submit/querycopyrightAgreement",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findAuthorByPhoneAndName(data) {
    //添加作者
    return request({
      url: dev + "/web/submit/findAuthorByPhoneAndName",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  sendAliyunVerifyCode(data) {
    //阿里短信验证码发送
    return request({
      url: dev + "/sys/aliyunVerifyCode/sendAliyunVerifyCode",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  aliyunVerifyCode(data) {
    //阿里验证码校验
    return request({
      url: dev + "/sys/aliyunVerifyCode/aliyunVerifyCode",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  delFile(data) {
    //删除文件
    return request({
      url: dev + "/web/common/delFile",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getAnnexStatus(data) {
    //获取稿件附件上传开关
    return request({
      url: dev + "/web/submit/getAnnexStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getContribute(data) {
    //获取稿件附件上传开关
    return request({
      url: dev + "/web/submit/getContribute",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /* start 老接口，根据省查询市 */
  findProvinceList(data) {
    //省
    return request({
      url: dev + "/web/common/findProvinceList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findAreaList(data) {
    //市
    return request({
      url: dev + "/web/common/findAreaList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /* end 老接口，根据省查询市 */
  
  // 新接口，直接返回省和市完整数据，需整理成组件所需数据格式
  provinceCityTree(data) {
    //省市
    return request({
      url: dev + "/web/common/provinceCityTree",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  treeList(data) {
    //学科树结构
    return request({
      url: dev1 + "/subject/treeList",
      method: "get",
      params: data,
      isToken: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  subjectList(data) {
    //学科列表
    return request({
      url: dev1 + "/subject/list",
      method: "get",
      params: data,
      isToken: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  ssoSubject(prevId) {
    //学科列表
    return request({
      url: dev1 + "/subject/list",
      method: "get",
      params: {
        prevId: prevId || 0,
      },
      isToken: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  titleList(data) {
    //职称列表
    return request({
      url: dev1 + "/zw/title/list",
      method: "post",
      data: data,
      isToken: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  registerAuthor(data) {
    //添加作者信息
    return request({
      url: dev + "/web/submit/registerAuthor",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  saveArticle(data) {
    //投稿下一步
    return request({
      url: dev + "/web/submit/saveArticle",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  saveArticleForDraft(data) {
    //投稿保存
    return request({
      url: dev + "/web/submit/saveArticleForDraft",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //畅写强制保存
  checkFile(data) {
    return request({
      url: dev + "/web/submit/checkFile",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findAuthorByAuthorId(data) {
    //根据id查询作者信息
    return request({
      url: dev + "/web/submit/findAuthorByAuthorId",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryArticleInfoById(data) {
    //根据id查询作者信息
    return request({
      url: dev + "/web/submit/queryArticleInfoById",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryArticleInfoAuthor(data) {
    //根据id查询作者信息
    return request({
      url: dev + "/web/submit/queryArticleInfoAuthor",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getAdvsert(data) {
    //广告设置
    return request({
      url: dev + "/web/submit/getAd",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  submitArticle(data) {
    //投稿提交
    return request({
      url: dev + "/web/submit/submitArticle",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateWordToPdf(data) {
    //更新pdf
    return request({
      url: dev + "/web/submit/updateWordToPdf",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getQrCode(data) {
    //生成付款码/web/order/getQrCode分账的/web/orderSub/getQrSubCode
    return request({
      url: dev + "/web/orderSub/getQrSubCode",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  billQuery(data) {
    //账单查询/web/order/billQuery分账的/web/orderSub/billSubQuery
    return request({
      url: dev + "/web/orderSub/billSubQuery",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateInvoiceStatus(data) {
    return request({
      url: dev + "/web/orderSub/updateInvoiceStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 批注文档
  processing(data) {
    return request({
      url: dev + "/web/myArticle/queryPostilFileInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  //查重报告
  Article(data) {
    return request({
      url: dev + "/web/myArticle/querycheckArticleFile",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取订单信息
  queryOrderId(data) {
    return request({
      url: dev + "/web/myArticle/queryOrderId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //论文模版 thesisTemplet
  thesisTemple(data) {
    return request({
      url: dev + "/web/per/thesisTemplet",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*我的投稿*/
  queryPerAndUserId(data) {
    //通过期刊id以及作者id查询采编
    return request({
      url: dev + "/web/submit/queryPerAndUserId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编名片列表
  pageEdit(data) {
    return request({
      url: "/api/zw-chat/editing_card/page",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //
  contributionEditList(data) {
    return request({
      url: "/api/zw-chat/editing_card/contributionEditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  myArticleCount(data) {
    //投稿列表统计
    return request({
      url: dev + "/web/myArticle/count",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  myArticleList(data) {
    //投稿列表
    return request({
      url: dev + "/web/myArticle/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  articleDetail(data) {
    //稿件详情
    return request({
      url: dev + "/web/myArticle/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  paymentDetail(data) {
    //付款确认详情
    return request({
      url: dev + "/web/myArticle/payment",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  generateOrders(data) {
    //邮寄地址
    return request({
      url: dev + "/web/myArticle/generateOrders",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  editAddtess(data) {
    //修改邮寄地址
    return request({
      url: dev + "/web/myArticle/editAddtess",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  myArticleReturn(data) {
    //退回
    return request({
      url: dev + "/web/myArticle/return",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateArticleFlag(data) {
    //转至废件箱、恢复
    return request({
      url: dev + "/web/myArticle/updateArticleFlag",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  invoiceBill(data) {
    //费用发票
    return request({
      url: dev + "/web/myArticle/invoiceBill",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  articleBill(data) {
    //保存发票
    return request({
      url: dev + "/web/myArticle/articleBill",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  publishProgress(data) {
    //发表进度
    return request({
      url: dev + "/web/myArticle/publishProgress",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*费用管理*/
  myOrderList(data) {
    //订单列表
    return request({
      url: dev + "/web/myOrder/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  myOrderDetail(url,data) {
    //订单详情
    return request({
      url: dev + url,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  abolish(data) {
    //取消订单/web/order/abolish分账的/web/orderSub/abolishSub
    return request({
      url: dev + "/web/orderSub/abolishSub",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateOrder(data) {
    //订单刷新
    return request({
      url: dev + "/web/orderSub/updateOrder",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  resetPreposition(data) {
    //订单重置前查询
    return request({
      url: dev + "/web/orderSub/resetPreposition",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  orderReset(data) {
    //订单重置
    return request({
      url: dev + "/web/orderSub/reset",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*发票查询*/
  invoiceList(data) {
    //列表
    return request({
      url: dev + "/web/myArticle/invoiceList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  returnBill(data) {
    //发票退回
    return request({
      url: dev + "/web/myArticle/returnBill",
      method: "delete",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryBilldetails(data) {
    //发票展示
    return request({
      url: dev + "/web/myArticle/queryBilldetails",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  viewBill(data) {
    //查看发票
    return request({
      url: dev + "/web/myArticle/viewBill",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  confirmInvoiceBill(data) {
    //发票保存
    return request({
      url: dev + "/web/myArticle/confirmInvoiceBill",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*废件箱*/
  queryDiscardArticleList(data) {
    //列表
    return request({
      url: dev + "/web/myArticle/queryDiscardArticleList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 撤稿
  waidith(data) {
    return request({
      url: dev + "/web/submit/updateArticle",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*其他设置*/
  //消息通知
  queryMessageList(data) {
    //列表
    return request({
      url: dev + "/web/message/queryMessageList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  deleteMessageList(data) {
    //消息删除
    return request({
      url: dev + "/web/message/deleteMessageList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  readMessage(data) {
    //读
    return request({
      url: dev + "/web/message/readMessage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //基本资料
  getUserInfo(data) {
    //详情
    // return request({
    // 	url: dev + "/web/sso/getUserInfo",
    // 	method: 'post',
    // 	data: data,
    // }).then((result) => {
    // 	return Promise.resolve(result.data)
    // })
    return request({
      url: "/api/zw-user/getUserDetail",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  scholar(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-user/register/nf/scholar",
      data,
      false
    );
  },
  // //注册
  // register(data, url) {
  // 	return HTTP.json(url + "/api/zw-user/register/user", data, false);
  // },
  //未注册用户投稿时进行注册
  registerOrBecomeScholar(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-user/scholar/nf/registerOrBecomeScholar",
      data,
      false
    );
  },
  //根据用户id查用户详情
  getUserDetailByUserId(data) {
    return HTTP.post(
      global.global.url3 + "/api/zw-user/nf/getUserDetailByUserId",
      data,
      false
    );
  },
  //修改基本资料
  editModifyBaseInfo(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-user/scholar/nf/editModifyBaseInfo",
      data,
      false
    );
  },
  setUserInfo(data) {
    //基本资料保存
    return request({
      url: dev + "/web/sso/setUserInfo",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //根据期刊id获取期刊名称和logo
  getPerInfo(data) {
    return request({
      url: dev + "/web/per/getPer",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编详情
  getEditingInfo(data) {
    return request({
      url: dev + "/web/myArticle/getEditingInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //补充附件 /web/myArticle/getAnnexApplyInfo跳转到补充附件页面
  getAnnexApplyInfo(data) {
    return request({
      url: dev + "/web/myArticle/getAnnexApplyInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //补充附件
  saveAnnexInfo(data) {
    return request({
      url: dev + "/web/myArticle/saveAnnexInfo",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //查询是否有未完成稿件
  checkHasUndo(data) {
    return request({
      url: dev + "/web/myArticle/checkHasUndo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //验证用户信息是否完善
  checkUserInfo(data) {
    return request({
      url: dev + "/web/submit/checkUserInfo",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //下载通用接口
  downloadCommon(data) {
    return request({
      url: dev + "/web/download/downloadCommon",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  permissionList(data) {
    return request({
      url: dev + "/sys/permissionList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  selPerList(data) {
    return request({
      url: dev + "/web/selPerList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //退修文献推荐
  recommendList(data) {
    return request({
      url: dev + "/web/paper/recommendList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //退修意见以及审核结果
  queryArticleId(data) {
    return request({
      url: dev + "/web/submit/queryArticleId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //根据用户id查询已检索过的期刊
  getPeriodicalByUserId(data) {
    return request({
      url: dev + "/web/per/getPeriodicalByUserId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //新增跳转期刊记录
  periodicalRecord(data) {
    return request({
      url: dev + "/web/per/periodicalRecord",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //删除跳转期刊记录
  returnPeriodicalByUserId(data) {
    return request({
      url: dev + "/web/per/returnPeriodicalByUserId",
      method: "delete",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //根据期刊名称模糊查询
  getPeriodicalByName(data) {
    return request({
      url: dev + "/web/per/getPeriodicalByName",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取中文知识网加密方式
  getPk(data) {
    return request({
      url: "/api/zw-user/getPk",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getUserIpConfig() {
    return new Promise((resolve, reject) => {
      jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=OWOBZ-6CZKQ-44B5T-2WQIO-YUTJ7-5TFJO`, {
        output: 'jsonp',
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  },
  // 注册登录找回密码
  login(data, url) {
    return HTTP.json(url + "/api/zw-user/bj/login", data, false);
  },
  logOut(data) {
    // return request({
    // 	url: "/api/zw-user/logout",
    // 	method: 'post',
    // 	data: data,
    // }).then((result) => {
    // 	return Promise.resolve(result.data)
    // })
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-user/logout",
      data,
      false
    );
  },
  //获取验证码
  sendCode(data, url) {
    return HTTP.get(
      global.global.url3 + "/api/zw-public/sms/sendNew",
      data,
      false
    );
  },
  //修改密码
  userRetrievePwd(data, url) {
    return HTTP.post(
      url + "/api/zw-user/reset/nf/userRetrievePwd",
      data,
      false
    );
  },
  //注册
  register(data, url) {
    return HTTP.json(url + "/api/zw-user/register/user", data, false);
  },

  //http://47.93.50.49:5052/api/zw-public/title/getOneList
  //研究方向获取
  //http://127.0.0.1:8088/tsg-author/api/zw-public/title/getOneList?time=1637818647762

  direction(data) {
    return request({
      url: "/api/zw-public/title/getTitleList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //研究方向二级
  secondary(data) {
    return request({
      url: "/api/zw-public/title/getTwoList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //研究方向三级
  seThreeList(data) {
    return request({
      url: "/api/zw-public/title/getThreeList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  direFlife(data) {
    return request({
      url: "/api/zw-public/researchField/getOneList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  seconFlife(data) {
    return request({
      url: "/api/zw-public/researchField/getTwoList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  seThrFlife(data) {
    return request({
      url: "/api/zw-public/researchField/getThreeList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //得到全部研究方向
  getRelationList(data) {
    return request({
      url: "/api/zw-public/researchField/getRelationList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取学历数据
  getEduDictionary(data) {
    return request({
      url: "/api/zw-public/code/getEduDictionary",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取单位级别数据
  getLevleList(data) {
    return request({
      url: dev + "/web/submit/getLevleList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  //用户信息
  modifyBaseInfo(data) {
    return request({
      url: "/api/zw-user/scholar/modifyBaseInfo",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //选择采编
  //浏览记录
  cardBrowse(data) {
    return request({
      url: "/api/zw-chat/editing_center/cardBrowse",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //删除浏览记录
  delBrowse(data) {
    return request({
      url: "/api/zw-chat/editing_center/delBrowse",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //收藏
  cardHolder(data) {
    return request({
      url: "/api/zw-chat/editing_center/cardHolder",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //删除
  delHolder(data) {
    return request({
      url: "/api/zw-chat/editing_center/delHolder",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //消息列表
  msgList(data) {
    return request({
      url: "/api/zw-chat/myCard/msgList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取聊天内容
  getChatPage(data) {
    return request({
      url: "/api/zw-chat/chat/getChatPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编名片详情
  getEditingDetail(data) {
    return request({
      url: "/api/zw-chat/editing_card/getEditingInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //二维码  http://wxtest.cnknowledge.com/api/zw-wechat/weixin/nf/getCode
  wchardList(data) {
    return request({
      url: "api/zw-wechat/weixin/nf/getCode",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //微信头像http://wxtest.cnknowledge.com/api/zw-wechat/userInfo/nf/getWechatUserInfo
  wchardtoup(data) {
    return request({
      url: "api/zw-wechat/userInfo/nf/getWechatUserInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  binding(data) {
    return request({
      url: "api/zw-wechat/wechatOffcialAccount/nf/unbindWechat",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 提交投诉
  articleList(data) {
    return request({
      url: dev + "/web/complaint/saveComplaintInfo",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 切换期刊
  livtTop(data) {
    return request({
      url: dev + "/web/per/getPeriodicalByName",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 采编中心
  acardslist(data) {
    return request({
      url: "/api/zw-chat/myCard/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  detailsLive(data) {
    return request({
      url: "/api/zw-chat/editing_index/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  detivesList(data) {
    return request({
      url: "/api/zw-chat/editing_card/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  Announ(data) {
    return request({
      url: "/tsg-author/web/publication/queryPublicationList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  literaturePage(data) {
    return request({
      url: "/api/zw-chat/myCard/recommendPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  authorlist(data) {
    return request({
      url: "/api/zw-chat/myCard/authorList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  statist(data) {
    return request({
      url: "/api/zw-chat/statistics/myPerformance",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getChatId(data) {
    return request({
      url: "/api/zw-chat/chat/getGroupId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  yejisutter(data) {
    return request({
      url: "/api/zw-chat/statistics/myContributer",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updeat(data) {
    return request({
      url: "/api/zw-chat/editing_card/tsgUpd",
      method: "post",
      data: data,
      rsa: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // litesyPage(data) {
  //   return request({
  //     url: "/api/zw-chat/editing_index/recommendPage",
  //     method: "get",
  //     params: data,
  //   }).then((result) => {
  //     return Promise.resolve(result.data);
  //   });
  // },
  chaxuTui(params) {
    return HTTP.json(
      BASE_URL + "/zw-information/adminInfo/getRecommend",
      params,
      false
    );
  },
  literaTop(params) {
    return HTTP.put(BASE_URL + "/zw-chat/myCard/top", params, false);
  },
  literaDelet(params) {
    return HTTP.delete(BASE_URL + "/zw-chat/myCard/del", params, false);
  },
  upName(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/updName", params, false);
  },
  recoveryName(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/recoveryName", params, false);
  },
  literature(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/recommend", params, false);
  },
  // 2023/11 新增作者校样
  // 校样详情 /web/artProof/detail

  proofDetail(data) { 
    return request({
      url: dev + "/web/artProof/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 确认校样 /web/artProof/confirm
  proofConfirm(data) {
    return request({
      url: dev + "/web/artProof/confirm",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // v3.0.4 2024/8/24 投稿时查询附件设置 /web/submit/getAnnexConfig
  requestAnnexConfig(params) { 
    return request({
      url: dev + "/web/submit/getAnnexConfig",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 投稿完成页附件说明弹窗信息 /web/submit/getAnnexPopup

  getAnnexsDescription(params) { 
    return request({
      url: dev + "/web/submit/getAnnexPopup",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  accountIsExist(data) {
    return HTTP.post(BASE_URL + "/zw-user/user/nf/account/isExist", data, false);
  },
  // v3.0.4订单详情页，查询当前节点是否需要拦截（是否存在必传附件未上传）
  // /web/myOrder/annexIntercept 附件是否拦截-3.0.4
  annexInterceptStatus(params) { 
    return request({
      url: dev + "/web/myOrder/annexIntercept",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  }, 
  //v3.0.4 拦截补充附件 /web/myOrder/supplementAnnex
  orderSupplementAnnex(data) {
    return request({
      url: dev + "/web/myOrder/supplementAnnex",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 获取期刊登录自定义设置-3.0.5
  queryLoginConfig(data) {
    return request({
      url: dev + "/web/per/queryPeriodicalLoginSet",
      method: "get",
      params: data
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 获取
  captchaPhone(data) {
    return request({
      url: "/api/zw-public/captcha/",
      method: "get",
      params: {phone:data}
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 校验
  captchaVerify(data) {
    return HTTP.postFormData(
        global.global.url3 + "/api/zw-public/captcha/verify",
        data,
        false
    );
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/manage.serve.js